//Generated File 
export const AlwaysSaveAndCommit = `AlwaysSaveAndCommit`;
export const AlwaysSaveAsDraft = `AlwaysSaveAsDraft`;
export const BasedOnRecordStatus = `BasedOnRecordStatus`;
